import { Spin, Space, Typography, Collapse, Flex, Radio, message, Form, Tooltip, Checkbox, Tabs, Select, Row, Table, Empty, Pagination } from "antd";
import { LoadingOutlined, DownOutlined, WarningOutlined } from "@ant-design/icons";
// import type { UploadRequestOption } from 'rc-upload/lib/interface';
import type { CheckboxGroupProps } from 'antd/es/checkbox';
import React, { useEffect, useState, useMemo, useCallback } from "react";
// import cloudUploadIcon from './../../../../../assets/svgs/cloudUploadIcon.svg'
// import loaderGif from './../../../../../assets/imgs/loaderGif.gif'
import { StyledButton } from "src/styled_components/StyledButton";
import { StyledCard } from "src/styled_components/StyledCard";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "src/store/configureStore";
import { AsyncStates } from "src/constants";
import { getPropertiesExtrapolationRequest, getWorkOrderBayesianDataCleanup, getWorkOrderBayesianDataRequest } from "src/store/actions/extrapolation";
import useTranslate, { TranslationKey } from "src/utils/useTranslate";
import { red } from "@ant-design/colors";
import { useValue } from "src/utils/useValue";




const { Text } = Typography;
// const { Dragger } = Upload;
const { Option } = Select

const workOrderOptions: CheckboxGroupProps['options'] = [
    { label: 'Formulations', value: 'ingredients' },
    { label: 'Processing', value: 'processing' },
    { label: 'Properties', value: 'properties' },]

// const UPLOAD_WORK_DATA = "Upload Data"
// const SELECT_WORK_ORDER = "Select Work Order"


const FETCH_KEY = "fetch";
const RESULT_KEY = "result";
type DataTypeKey = 'ingredients' | 'processing' | 'properties' | 'formulations';
type ObjectiveItem = { id: number;[key: string]: any };
interface GetDataProps {
    initialConstraintsRef: React.MutableRefObject<{ ingredients: any[]; processing: any[]; characterization: any[]; } | null>;
    workOrder: string[];
    setSelectedWorkOrder: React.Dispatch<React.SetStateAction<string[]>>;
    trialInputsData: Record<DataTypeKey, string[]>;
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    userIgnoredData: Record<DataTypeKey, string[]>;
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>
    FormData: any;
    setRows: React.Dispatch<React.SetStateAction<ObjectiveItem[]>>;
    setConstraintRows: React.Dispatch<React.SetStateAction<{
        ingredients: any[];
        processing: any[];
        //characterization: any[];
    }>>;
    setPredictExperiment: React.Dispatch<React.SetStateAction<{ kappaValue: number, suggestedExperiments: number }>>;
}

interface uploadDataProps {
    initialConstraintsRef: React.MutableRefObject<{ ingredients: any[]; processing: any[]; characterization: any[]; } | null>;
    workOrder: string[],
    setSelectedWorkOrder: React.Dispatch<React.SetStateAction<string[]>>;
    pagination: { current: number, pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number, pageSize: number }>>;
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    FormData: any;
    setRows: React.Dispatch<React.SetStateAction<ObjectiveItem[]>>;
    setConstraintRows: React.Dispatch<React.SetStateAction<{
        ingredients: any[];
        processing: any[];
        //characterization: any[];
    }>>;
    setPredictExperiment: React.Dispatch<React.SetStateAction<{ kappaValue: number, suggestedExperiments: number }>>;
}

interface SelectWorkOrderProps {
    workOrder: string[];
    setSelectedWorkOrder: React.Dispatch<React.SetStateAction<string[]>>;
    FormData: any;
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
}

interface WorkOrdersDataProps {
    data: any;
    workOrder: string[];
    getWorkOrderBayesianDataStatus: string;
    pagination: { current: number, pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number, pageSize: number }>>;
    trialInputsData: Record<DataTypeKey, string[]>;
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    userIgnoredData: Record<DataTypeKey, string[]>;
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    setUnsavedChanges?: React.Dispatch<React.SetStateAction<boolean>>;
    from?: string;
    workOrderName?: string;

}

interface WorkOrderTableProps {
    dataCount: number;
    filterData: any;
    type: string;
    pagination: { current: number, pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number, pageSize: number }>>;
    totalWorkOrderId: string[];
    activeWorkOrderId: string;
    trialInputsData: Record<DataTypeKey, string[]>;
    setTrialInputsData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    userIgnoredData: Record<DataTypeKey, string[]>;
    setUserIgnoredData: React.Dispatch<React.SetStateAction<Record<DataTypeKey, string[]>>>;
    setUnsavedChanges?: React.Dispatch<React.SetStateAction<boolean>>;
    propertyTrainWarnings: any;
    from?: string;
}


const GetData: React.FC<GetDataProps> = (props: GetDataProps) => {
    const { workOrder, setSelectedWorkOrder, trialInputsData, setTrialInputsData, userIgnoredData, setUserIgnoredData, setUnsavedChanges, FormData, setRows, setConstraintRows, setPredictExperiment, initialConstraintsRef } = props;
    const [t] = useTranslate();
    const { getWorkOrderBayesianDataStatus, workOrderBayesianData } = useSelector(
        (state: StoreState) => state.extrapolation,
    )
    const [activeKeys, setActiveKeys] = useState<string[]>([FETCH_KEY]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })

    useEffect(() => {
        if (getWorkOrderBayesianDataStatus === AsyncStates.SUCCESS) {
            // Close fetch panel, open result panel
            setActiveKeys((prevKeys) => [
                ...new Set([...prevKeys?.filter(k => k !== FETCH_KEY), RESULT_KEY]),
            ]);
        } else if (getWorkOrderBayesianDataStatus === AsyncStates.LOADING) {
            // Ensure result panel is open during loading
            setActiveKeys((prevKeys) =>
                prevKeys?.includes(RESULT_KEY) ? prevKeys : [...prevKeys, RESULT_KEY]
            );
        }
    }, [getWorkOrderBayesianDataStatus]);

    const togglePanel = (key: string | string[]) => {
        setActiveKeys(Array.isArray(key) ? key : [key]);
    };



    return (
        <Space direction="vertical" style={{ marginTop: 38, width: "100%" }} size="large">
            <Space direction="vertical">
                <Text>
                    {/* Upload Data or select work order to start optimisation */}
                    {t("extrapolation.getData.selectWorkOrder")}
                </Text>
            </Space>
            <Space direction="vertical" style={{ width: "100%" }}>
                <Collapse
                    activeKey={activeKeys}
                    onChange={togglePanel}
                    items={[
                        {
                            key: FETCH_KEY,
                            label: "Fetch Data",
                            children: <UploadDataOptions initialConstraintsRef={initialConstraintsRef} setPredictExperiment={setPredictExperiment} setRows={setRows} setConstraintRows={setConstraintRows} FormData={FormData} setTrialInputsData={setTrialInputsData} setUserIgnoredData={setUserIgnoredData} pagination={pagination} setPagination={setPagination} workOrder={workOrder} setSelectedWorkOrder={setSelectedWorkOrder} />,
                        },
                    ]}
                />
            </Space>
            {(getWorkOrderBayesianDataStatus === AsyncStates.LOADING || getWorkOrderBayesianDataStatus === AsyncStates.SUCCESS) && <Space direction="vertical" style={{ width: "100%" }}>
                <Spin spinning={getWorkOrderBayesianDataStatus === AsyncStates.LOADING} indicator={<LoadingOutlined />} >
                    <Collapse
                        activeKey={activeKeys}
                        onChange={togglePanel}
                        items={[
                            {
                                key: RESULT_KEY,
                                label: "Work Orders Data",
                                children: <WorkOrdersData setUnsavedChanges={setUnsavedChanges} trialInputsData={trialInputsData} setTrialInputsData={setTrialInputsData} userIgnoredData={userIgnoredData} setUserIgnoredData={setUserIgnoredData} pagination={pagination} setPagination={setPagination} data={workOrderBayesianData} workOrder={workOrder} getWorkOrderBayesianDataStatus={getWorkOrderBayesianDataStatus} />,
                            },
                        ]}
                    />
                </Spin>
            </Space>}
        </Space>)
}

export default GetData;

function UploadDataOptions(props: uploadDataProps) {
    const { workOrder, setSelectedWorkOrder, pagination, setTrialInputsData, setUserIgnoredData, FormData, setRows, setConstraintRows, setPredictExperiment, initialConstraintsRef } = props;
    const [t] = useTranslate();

    const { current, selectAllProjects, } = useSelector(
        (state: StoreState) => state.projects,
    )
    const dispatch = useDispatch();
    //const [selected, setSelected] = useState("Upload Data");
    // const handleRadioChange = (e: import("antd").RadioChangeEvent) => {

    //     setSelected(e.target.value);

    // };


    const handleSubmit = () => {

        if (!workOrder.length) {
            message?.error(t("extrapolation.getData.selectWorkOrderError"));
            return;
        }
        let payload: any = {
            page_num: pagination.current,
            page_size: pagination.pageSize,
            input_types: ["ingredients", "processing"],
            output_types: ["properties"],
            applications: [],
            materials: [],
            work_order_ids: !!workOrder?.length ? [workOrder?.[0]] : [],
            total_work_order_ids: workOrder,
            formulation_ids: [],
            project_ids: selectAllProjects ? [] : [current],
            stage_identifier: [],
            is_multi_stage: false
        }

        // if (selected === UPLOAD_WORK_DATA) {

        // }
        // else {
        dispatch(getWorkOrderBayesianDataRequest({ payload }))
        dispatch(getPropertiesExtrapolationRequest(workOrder?.[0]))
        setRows([{ id: Date.now(), error: false, errorType: "", errMsg: "" }])
        setConstraintRows({
            ingredients: [],
            processing: [],
            //characterization: []
        })
        setPredictExperiment({ kappaValue: 2.5, suggestedExperiments: 10 })
        initialConstraintsRef.current = null;
    }
    return (
        <>
            {/* <Flex vertical gap="large">
                <Radio.Group value={selected} onChange={handleRadioChange} options={options} defaultValue="Upload Data" />
            </Flex> */}
            {/* {selected === UPLOAD_WORK_DATA ? <UploadData /> : <SelectWorkOrder workOrder={workOrder} setSelectedWorkOrder={setSelectedWorkOrder} FormData={FormData} />} */}
            <SelectWorkOrder setTrialInputsData={setTrialInputsData} setUserIgnoredData={setUserIgnoredData} workOrder={workOrder} setSelectedWorkOrder={setSelectedWorkOrder} FormData={FormData} />
            <Row justify={"end"}>
                <StyledButton onClick={handleSubmit} type="primary">{t("extrapolation.getData")}</StyledButton>
            </Row>
        </>
    );
}

// function UploadData() {

//     const [defaultFileList, setDefaultFileList] = useState<any[]>([]);
//     const [uploading, setUploading] = useState(false)

//     const [showList, setShowList] = useState(false);


//     const uploadImage = (options: UploadRequestOption<any>): void => {
//         const { onSuccess, onError, file, onProgress } = options;
//         setUploading(true);

//         const fmData = new FormData();
//         fmData.append("image", file as File);
//         fetch("https://jsonplaceholder.typicode.com/posts", {
//             method: "POST",
//             body: fmData,
//         })
//             .then(async (res) => {
//                 await res.json();
//                 if (onSuccess) {
//                     onSuccess("ok");
//                     setUploading(false);
//                     setShowList(true);
//                 }
//             })
//             .catch((err) => {
//                 //console.log("Error: ", err);
//                 if (onError) {
//                     setUploading(false);
//                     onError(err);
//                 }
//             });
//     };

//     const handleOnChange = ({
//         file,
//         fileList,
//         event,
//     }: {
//         file: any;
//         fileList: any[];
//         event?: any;
//     }) => {
//         // console.log(file, fileList, event);
//         //Using Hooks to update the state to the current filelist
//         setDefaultFileList(fileList);
//         //filelist - [{uid: "-1",url:'Some url to image'}]
//     };

//     // const props: UploadProps = {
//     //     name: 'file',
//     //     multiple: true,
//     //     showUploadList: showList,
//     //     // Provide a real or mock API if needed
//     //     action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
//     //     onChange(info) {
//     //         const { status } = info.file;
//     //         console.log(status, "status");


//     //         if (status !== 'uploading') {
//     //   console.log(info.file, info.fileList);
//     // }
//     //         if (status === 'uploading') {
//     //             setUploading(true); // Show loader
//     //         }

//     //         if (status === 'done') {
//     //             setUploading(false);
//     //             setShowList(true); // Show uploaded file list
//     //             message.success(`${info.file.name} file uploaded successfully.`);
//     //         } else if (status === 'error') {
//     //             setUploading(false);
//     //             message.error(`${info.file.name} file upload failed.`);
//     //         }
//     //     },
//     //     onDrop(e) {
//     //         console.log('Dropped files', e.dataTransfer.files);
//     //     },
//     // };

//     return (<Space direction="vertical" style={{ width: "100%", marginTop: 24 }}>
//         <Space direction="vertical"><Text>Upload Data</Text></Space>
//         {uploading ? <UploadLoader /> : <Dragger showUploadList={showList} customRequest={uploadImage}
//             defaultFileList={defaultFileList}
//             onChange={handleOnChange}>
//             <Space direction="horizontal" size="middle">
//                 <span className="ant-upload-drag-icon" >
//                     <img src={cloudUploadIcon} alt={"cloudUpload"} />
//                 </span>
//                 <span className="ant-upload-text" style={{ color: '#1890FF', fontWeight: 700 }}>Click to Upload<span style={{ color: "#8C8C8C", fontWeight: 700 }}> or Drag and Drop</span></span>
//             </Space>
//             <p style={{ color: "#8C8C8C" }}>CSV or Excel File only</p>
//         </Dragger>}
//         <Space direction="horizontal">
//             <Text style={{ color: "#1890FF", textDecoration: "underline", cursor: "pointer" }}>Download our template </Text>
//             <Text style={{ marginLeft: -2 }}>to make sure your spreadsheet is formatted correctly.</Text>
//         </Space>
//     </Space>)
// }

// function UploadLoader() {
//     return (<Space direction="vertical" style={{ textAlign: "center", width: "100%", }}>
//         <img style={{ height: 70, }} src={loaderGif} alt={"loader"} />
//         <Text style={{ position: "relative", top: -25 }}>File is being Uploaded</Text>
//     </Space>)
// }

function SelectWorkOrder(props: SelectWorkOrderProps) {
    const { setSelectedWorkOrder, FormData, setTrialInputsData, setUserIgnoredData, workOrder } = props
    const [t] = useTranslate();
    const dispatch = useDispatch();

    const workOrders = useSelector((state: StoreState) => state.workOrders.data)
    const workOrdersStatus = useSelector(
        (state: StoreState) => state.workOrders.status,
    )

    const getFilteredWorkOrders = () => {
        return workOrders.filter(wo => wo.stages?.length === 1);
    };

    const handleChange = (value: string) => {
        setSelectedWorkOrder([value]);
        setTrialInputsData({
            ingredients: [],
            processing: [],
            properties: [],
            formulations: []
        })
        setUserIgnoredData({
            ingredients: [],
            processing: [],
            properties: [],
            formulations: []
        })
        dispatch(getWorkOrderBayesianDataCleanup())
    };

    return (<Space direction="vertical" style={{ width: "100%", marginTop: 24 }}>
        <Space style={{ width: '100%' }} direction="vertical">
            <Form form={FormData} >
                <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    name="work_order_ids"
                    label={"Select Work Order"}
                    rules={[
                        { required: true, message: t("extrapolation.getData.selectAtleastOneWorkOrder") },
                    ]}>
                    <Select
                        allowClear
                        showSearch
                        style={{ width: '40%', }}
                        placeholder="Select Work Order"
                        onChange={handleChange}
                        filterOption={(input, option) => {
                            return (option as any)?.children?.toLowerCase().includes(input.toLowerCase())
                        }}
                        value={workOrder?.[0]}

                    > {workOrdersStatus === AsyncStates.SUCCESS &&
                        getFilteredWorkOrders().map((res: any) => (
                            <Option
                                value={res.work_order_id}
                                key={res.work_order_id}
                            >
                                {res.work_order_name}
                            </Option>
                        ))}</Select></Form.Item></Form></Space>
    </Space>)
}


export function WorkOrdersData(props: WorkOrdersDataProps) {
    const dispatch = useDispatch();
    const [t] = useTranslate();
    const { data, workOrder, getWorkOrderBayesianDataStatus, pagination, setPagination, userIgnoredData, setUserIgnoredData, trialInputsData, setTrialInputsData, setUnsavedChanges, from, workOrderName } = props;
    const workOrders = useSelector((state: StoreState) => state.workOrders.data)
    const { current, selectAllProjects } = useSelector(
        (state: StoreState) => state.projects,
    )

    const [type, setType] = useState("ingredients");
    const [activeWorkOrderId, setActiveWorkOrderId] = useState(workOrder?.[0]);

    useEffect(() => {
        setActiveWorkOrderId(workOrder?.[0]);
    }, [workOrder])

    let totalCount = from==="history-prediction-details" ? data?.total_count - userIgnoredData?.formulations?.length || data?.total_formulation_ids_count-userIgnoredData?.formulations?.length || 0 : data?.total_count || data?.total_formulation_ids_count

    const handleRadioChange = (e: import("antd").RadioChangeEvent) => {
        setType(e?.target?.value);
    };

    const formatTabName = (name: string, woId: string) => {
        const formattedName = name ? name : woId;
        return formattedName?.length < 11 ? formattedName : <Tooltip title={formattedName}>{formattedName.substring(0, 10)}...</Tooltip>
    }
    return (<Space direction="vertical" style={{ width: "100%" }}>
        <Space direction="horizontal" size={"small"}>
            <Text>{t("extrapolation.getData.totalOrders")} {workOrder?.length}</Text>
            <Text>{t("extrapolation.getData.totalTrials")} {from==="history-prediction-details" ? data?.total_formulation_ids_count - userIgnoredData?.formulations?.length || 0 : data?.total_formulation_ids_count}</Text>
        </Space>

        <Flex vertical gap="large">
            <Radio.Group value={type} onChange={handleRadioChange} options={workOrderOptions} defaultValue="Upload Data" />
        </Flex>
        <Tabs defaultActiveKey={activeWorkOrderId} tabPosition={"top"} moreIcon={<DownOutlined />}
            activeKey={activeWorkOrderId} onTabClick={(key) => {

                let payload: any = {
                    page_num: 1,
                    page_size: 10,
                    input_types: ["ingredients", "processing"],
                    output_types: ["properties"],
                    applications: [],
                    materials: [],
                    work_order_ids: [key],
                    total_work_order_ids: workOrder,
                    formulation_ids: [],
                    project_ids: selectAllProjects ? [] : [current],
                    stage_identifier: [],
                    is_multi_stage: false
                }
                dispatch(getWorkOrderBayesianDataRequest({ payload }))
                setActiveWorkOrderId(key); setType('ingredients');
                setPagination({ current: 1, pageSize: 10 });
            }}
            items={(workOrder || [])?.map((woId: string) => {
                return {
                    label: from==="history-prediction-details" ? formatTabName(workOrderName ?? '',woId) : formatTabName(workOrders?.find((wo: any) => woId === wo.work_order_id)?.work_order_name, woId),
                    key: woId,
                    children: (
                        <>
                            <Row justify="center">
                                <Spin
                                    style={{ marginTop: "30px" }}
                                    spinning={getWorkOrderBayesianDataStatus === AsyncStates.LOADING}
                                    indicator={<LoadingOutlined />}
                                ></Spin>
                            </Row>
                            {!data?.dataframe?.length && getWorkOrderBayesianDataStatus !== AsyncStates.LOADING && (<Empty style={{ marginTop: "30px" }} />)}
                            {!!data?.dataframe?.length && (

                                <WorkOrderTable from={from} setUnsavedChanges={setUnsavedChanges} trialInputsData={trialInputsData} setTrialInputsData={setTrialInputsData} activeWorkOrderId={activeWorkOrderId} totalWorkOrderId={workOrder} pagination={pagination} setPagination={setPagination} userIgnoredData={userIgnoredData} setUserIgnoredData={setUserIgnoredData} type={type} dataCount={totalCount} filterData={data?.dataframe} propertyTrainWarnings={data?.property_train_warnings} />
                            )}
                        </>
                    ),
                };
            })} />

    </Space>)
}

function WorkOrderTable(props: WorkOrderTableProps) {
    const { dataCount, filterData, type, userIgnoredData, setUserIgnoredData, pagination, setPagination, totalWorkOrderId, activeWorkOrderId, trialInputsData: unignoredData, setTrialInputsData: setUnignoredData, setUnsavedChanges, propertyTrainWarnings, from } = props;
    const [t] = useTranslate();
    const dispatch = useDispatch();
    const { getValue } = useValue()

    const { current: currentProj, selectAllProjects } = useSelector(
        (state: StoreState) => state.projects,
    )

    const dispNames = useSelector((state: StoreState) => state.displayNames.data);
    const translateFirstColumnOfTable = (
        input: string,
        t: (key: TranslationKey) => string
    ) => {
        if (input === "ingredients") return t("common.ingredients");
        if (input === "processing") return t("common.processing");
        if (input === "properties") return t("common.properties");
        return t("common.ingredients");
    };

    const rowSelection = {
        onSelect: (record: any, selected: any) => {
            const key = record.key;
            const newIgnored = selected
                ? userIgnoredData[type as DataTypeKey]?.filter((d: string) => d !== key)
                : [...userIgnoredData[type as DataTypeKey], key];
            const newUnignored = selected
                ? [...unignoredData[type as DataTypeKey], key]
                : unignoredData[type as DataTypeKey]?.filter((d: string) => d !== key);

            setUserIgnoredData({ ...userIgnoredData, [type as DataTypeKey]: newIgnored });
            setUnignoredData({ ...unignoredData, [type as DataTypeKey]: newUnignored });
        },
        getCheckboxProps: (record: any) => {
            return ({
                name: record.ingredients || record.properties || record.processing,
            })
        },
    };

    const ingredientsDataInfo = useMemo(() => {
        const result = filterData?.reduce((acc: any, curr: any) => {
            return { ...acc, ...curr?.ingredients };
        }, {});
        return result;
    }, [filterData]);

    const tableData: any = useMemo(
        () => {
            if (from === "history-prediction-details") {
                const filterFormulation = filterData.filter((item: any) => !userIgnoredData.formulations.includes(item?.formulation_id));
                return customWorkOrderTableData(filterFormulation, type, ingredientsDataInfo, getValue)
            }
            return customWorkOrderTableData(filterData, type, ingredientsDataInfo, getValue)
        },
        [from, filterData, type, ingredientsDataInfo, getValue, userIgnoredData.formulations]
    );

    const filteredTableData = useMemo(() => {
        if (from === "history-prediction-details") {
            // Only show items whose key is in unignoredData[type as DataTypeKey]
            return tableData.filter((row: any) => !userIgnoredData[type as DataTypeKey]?.includes(row.key));
        }
        // If not "from", show all items
        return tableData;
    }, [from, tableData, type, userIgnoredData]);

    const toggleIgnoreFormulations = useCallback((checked: boolean, formulationId: string) => {
        const newIgnored = checked
            ? userIgnoredData?.formulations?.filter((d: string) => d !== formulationId)
            : [...userIgnoredData?.formulations, formulationId];
        const newUnignored = checked
            ? [...unignoredData?.formulations, formulationId]
            : unignoredData?.formulations?.filter((d: string) => d !== formulationId);

        setUserIgnoredData((prev: any) => ({ ...prev, formulations: newIgnored }));
        setUnsavedChanges?.(true);
        setUnignoredData((prev) => ({ ...prev, formulations: newUnignored }));
    }, [userIgnoredData?.formulations, unignoredData?.formulations, setUserIgnoredData, setUnsavedChanges, setUnignoredData]);



    // useEffect(() => {
    //     if (!type || !Array.isArray(tableData)) return;

    //     const currentUnignoredKeys = tableData?.map((item: any) => item?.key);
    //     setUnignoredData((prev) => ({
    //         ...prev,
    //         [type]: currentUnignoredKeys
    //     }));
    // }, [setUnignoredData, tableData, type]);

    useEffect(() => {
        if (!filterData?.length) return;

        const formulationIds = filterData?.map((item: any) => item?.formulation_id)?.filter(Boolean);
        const ingredients = Object.keys(filterData?.[0]?.ingredients || {})
        const processing = Object.keys(filterData?.[0]?.processing?.[0]?.processing || {})
        const properties = Object.keys(filterData?.[0]?.properties?.[0]?.properties || {})

        setUnignoredData((prev) => ({
            ...prev,
            formulations: formulationIds,
            ingredients,
            processing,
            properties
        }));
    }, [filterData, setUnignoredData]);


    const columns: any = useMemo(() => {
        const firstColumnTitle = translateFirstColumnOfTable(type, t);

        return [
            {
                title:
                    firstColumnTitle?.slice(0, 1)?.toLocaleUpperCase() +
                    firstColumnTitle?.slice(1),
                dataIndex: type,
                key: type,
                width: 200,
                fixed: "left",
                render: (text: any, record: any) => {
                    text = !text ? record?.key : text;
                    if (type === "properties") {
                        if (propertyTrainWarnings?.[text])
                            return (
                                <div style={{ padding: "8px" }}>
                                    <Text>{record?.display_name ?? dispNames?.properties?.[text]?.name ?? text}</Text>
                                    <Tooltip title={t("extrapolation.7DataPoints")}>
                                        {" "}
                                        <WarningOutlined style={{ color: red[5] }} />
                                    </Tooltip>
                                </div>
                            );
                        return <div style={{ padding: "8px" }}>{record?.display_name ?? dispNames?.properties?.[text]?.name ?? text}</div>
                    } else
                        return (
                            <div style={{ padding: "8px" }}>
                                {ingredientsDataInfo?.[text]?.name ||
                                    dispNames?.ingredients?.[text]?.name ||
                                    dispNames?.processing?.[text]?.name ||
                                    text}
                            </div>
                        );
                },
            },
            ...filterData
                ?.filter((res: any) => {
                    // If from "history-prediction-details", only include columns for trials in predictionHistoryDetails?.list_of_trials
                    if (from === "history-prediction-details") {
                        return !userIgnoredData?.formulations?.includes(res?.formulation_id);
                    }
                    return true;
                })
                .map((res: any) => ({
                    title: <Row align="middle" style={{ padding: "16px 0" }}>
                        {!from && <Checkbox checked={!userIgnoredData?.formulations?.includes(res?.formulation_id)} onChange={(e) => toggleIgnoreFormulations(e.target.checked, res?.formulation_id)} />}
                        &nbsp;&nbsp;{res?.meta?.display_id}
                    </Row>,
                    dataIndex: res?.meta?.display_id,
                    key: res?.meta?.display_id,
                    width: 150
                })),
        ];
    }, [type, t, filterData, ingredientsDataInfo, dispNames?.ingredients, dispNames?.processing, dispNames?.properties, propertyTrainWarnings, from, userIgnoredData?.formulations, toggleIgnoreFormulations]);

    return (
        <StyledCard>
            <Table
                title={() => (
                    <div style={{ marginBottom: "16px" }}>
                        <span className="highlighted">{'trials :'}</span>{" "}
                        {dataCount}
                    </div>
                )}
                rowSelection={!!from || type === "properties" ? undefined : {
                    selectedRowKeys: tableData.flatMap((d: any) => d.key)?.filter((key: any) => !userIgnoredData[type as DataTypeKey].includes(key)),
                    type: "checkbox",
                    ...rowSelection,
                    onChange: (selectedRowKeys: any, selectedRows) => {
                        //console.log(selectedRowKeys, selectedRows, "from table");
                        setUnsavedChanges?.(true);
                        if (selectedRowKeys.length === tableData.length) {
                            // All selected
                            setUserIgnoredData({ ...userIgnoredData, [type]: [] });
                            setUnignoredData({ ...unignoredData, [type]: tableData.map((d: any) => d.key) });
                        } else if (selectedRowKeys.length === 0) {
                            // None selected
                            setUserIgnoredData({ ...userIgnoredData, [type]: tableData.map((d: any) => d.key) });
                            setUnignoredData({ ...unignoredData, [type]: [] });
                        }
                    }
                }}
                pagination={false}
                columns={columns}
                bordered
                dataSource={filteredTableData}
                scroll={{ x: 450, y: 250 }}
            />
            <Pagination
                style={{ textAlign: "right", marginTop: "1rem" }}
                current={pagination?.current || 1}
                total={dataCount}
                pageSizeOptions={[10, 20, 30, 40, 50]}
                onChange={(current, pageSize) => {
                    let payload: any = {
                        page_num: current,
                        page_size: pageSize,
                        input_types: ["ingredients", "processing"],
                        output_types: ["properties"],
                        applications: [],
                        materials: [],
                        work_order_ids: [activeWorkOrderId],
                        total_work_order_ids: totalWorkOrderId,
                        formulation_ids: [],
                        project_ids: selectAllProjects ? [] : [currentProj],
                        stage_identifier: [],
                        is_multi_stage: false
                    }
                    dispatch(getWorkOrderBayesianDataRequest({ payload }))
                    setPagination({ current, pageSize })
                }}
                showTotal={(total) => `Total ${dataCount || filterData.length} Items`} />
        </StyledCard>)
}


export const customWorkOrderTableData = (
    data: any,
    type: any,
    ingredientsDataInfo: any,
    getValue: any
) => {
    if (type === "ingredients") {
        return [
            ...[
                ...new Set(
                    data?.flatMap((res: any) => Object.keys(res?.ingredients || {})),
                ),
            ].map((ingredients: any, idx: number) => ({
                ...data?.reduce((a: any, o: any) => {
                    return {
                        ...a,
                        [ingredientsDataInfo?.[o.meta.display_id]?.name ??
                            o.meta.display_id]: getValue(
                                o?.ingredients?.[ingredients]?.value,
                            ),
                        key: ingredients,
                    }
                }, {}),
                ingredients,
            })),
        ]
    } else {
        return [
            ...[
                ...new Set(
                    data.flatMap((res: any) =>
                        Object.keys(res?.[type]?.[0]?.[type] || {}),
                    ),
                ),
            ].map((element: any, idx: number) => ({
                ...data?.reduce(
                    (a: any, o: any) => ({
                        ...a,
                        [o.meta.display_id]: getValue(
                            o?.[type]?.[0]?.[type]?.[element]?.value,
                        ),
                        key: element,
                        display_name: o?.[type]?.[0]?.[type]?.[element]?.display_name
                    }),
                    {},
                ),
                [type]: element,
            })),
        ]
    }
}
